<template>
  <Navbar />
  <ScrollButton />

  <!-- Hero Banner -->
  <section class="banner-title" style="background-image: url(images/arge3.png)">
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-12">
          <h1>Prototip Üretimi</h1>
        </div>
        <div class="col-md-6 col-sm-12">
          <ul class="bread-crumb" aria-label="breadcrumb">
            <li><a href="/">Anasayfa</a></li>
            <li class="active" aria-current="page">Prototip Üretimi</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!-- Content Section -->
  <section class="page-section" id="portfolio">
    <div class="container">
      <!-- Başlık -->
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <h2 class="text">Prototip Kartlar ve Test Üretimleri</h2>
        <div class="line"></div>
      </div>

      <!-- Tanıtım Metni -->
      <div class="row">
        <div class="col-lg-10 offset-lg-1 col-md-12 text-center">
          <h3 class="section-subtitle">Fikirden Ürüne Giden Yolda Yanınızdayız</h3>
          <p>
            İntek, elektronik prototip üretimi alanında hızlı ve kaliteli çözümler sunar.
            Kart tasarımından devre üretimine kadar tüm süreçlerde projelerinize özel çözümler geliştiriyoruz.
          </p>
          <h3 class="section-subtitle">Özelleştirilebilir Çözümler</h3>
          <p>
            Müşteri taleplerine göre özel donanım ve yazılım prototipleri geliştirerek projelerinizi başarıya ulaştırıyoruz.
          </p>
        </div>
      </div>

      <!-- Galeri -->
      <!-- <div class="row">
        <div class="text-uppercase line-wrapper mt-5">
          <h2 class="section-subtitle">Galeri</h2>
          <div class="line"></div>
        </div>

        <div
          class="col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
          v-for="(item, index) in pros"
          :key="index"
        >
          <div class="portfolio-item">
            <a class="portfolio-link" data-bs-toggle="modal" :href="'#portfolioModal' + index">
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
              <img
                class="img-fluid"
                :src="item.logo"
                :alt="item.baslik || 'Prototip Görseli'" loading="lazy" decoding="async"
              />
            </a>
          </div>
        </div>
      </div> -->
    </div>
  </section>

  <Footer />

  <!-- Modal Galeri -->
  <div
    class="portfolio-modal modal fade"
    v-for="(item, index) in pros"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="close-modal" data-bs-dismiss="modal">
          <img src="images/close-icon.svg" alt="Kapat" />
        </div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="modal-body">
                <img
                  :src="item.logo"
                  :alt="item.baslik || 'Prototip Detay Görseli'" style="max-width: 100%; height: auto; border-radius: 8px;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const pros = ref([]);

onMounted(async () => {
  const q = query(collection(firestore, "prototip"), where("durum", "==", true));
  const snapshot = await getDocs(q);
  const veri = [];
  snapshot.forEach((doc) => veri.push({ ...doc.data(), id: doc.id }));
  pros.value = veri;
});

useHead({
  title: "Prototip Üretimi | İntek Elektronic",
  meta: [
    {
      name: "description",
      content: "Elektronik kart ve gömülü sistem projeleri için hızlı ve güvenilir prototip üretimi. İntek ile fikirlerinizi hayata geçirin.",
    },
    {
      name: "keywords",
      content: "prototip üretimi, elektronik prototip, kart üretimi, pcb prototip, hızlı prototipleme, intek",
    },
    {
      property: "og:title",
      content: "Prototip Üretimi | İntek Elektronic",
    },
    {
      property: "og:description",
      content: "Elektronik kart ve gömülü sistem projeleri için hızlı ve güvenilir prototip üretimi. İntek ile fikirlerinizi hayata geçirin.",
    },
    {
      property: "og:image",
      content: "https://www.intekelectronic.com.tr/images/arge3.png",
    },
    {
      property: "og:url",
      content: "https://www.intekelectronic.com.tr/prototip-uretimi",
    },
  ],
});
</script>

<style scoped>
.portfolio-item {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.portfolio-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  border-radius: 4px;
}

.portfolio-item:hover img {
  transform: scale(1.05);
}

.portfolio-hover {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.portfolio-link:hover .portfolio-hover {
  opacity: 1;
}

.portfolio-hover-content {
  color: #fff;
  font-size: 2rem;
}
.portfolio-caption {
  text-align: center;
  margin-top: 0.5rem;
}
.section-subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #222;
}
p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 1.5rem;
  text-align: center;
}

.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.8rem;
  }
  h2.section-title,
  h2.section-subtitle {
    font-size: 1.4rem;
  }
  h3 {
    font-size: 1.1rem;
  }
}
</style>
